/**
 * Created by Alex Xia on 11/17/2020.
 * Description:
 * ------ maintenance history ------
 * Update by Marcus 6/21/2021
 *  Support clickSearchNearby() and add showNearby and searchby actions to set marker data;
 * Update by Marcus 9/1/2021  Code refactor for get nearby data.
 * Update by Marcus 7/23/2022 add id to distinguish between different tile id.
 */
import { Component, OnDestroy, OnInit, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import * as _lodash from 'lodash';

import { TamDashboardActions, TamDashboardEvents } from '../tam-dashboard.model';
import { filter } from 'rxjs/operators';
import { TamDashboardTileBaseComponent } from '../tam-dashboard-tile.base.component';
import { TamDashboardMapTileConfiguration, TamDashboardTileData } from './tam-dashboard-map-tile.config';
import { MapAction, MapConfig } from './tam-dashboard-map/tam-dashboard-map.model';
import { AutocompleteActionType, MapContactModel } from './tam-dashboard-map-autocomplete/tam-dashboard-map-autocomplete.model';
import { businessConstants } from '../../../constants/business.constants';
import { businessConstants as businessConstantsLibs } from '../../../tamalelibs/constants/business.constants';
import { MapTripActionType } from './map-trip/map-trip.model';
import { getSystemConfigState } from '../../../redux/reducers/system-config-view.reducer';
import { StoreQuerierService } from '../../../services/store-querier.service';
import { Contact } from '../../../tamalelibs/models/contact.model';
import { Entity } from '../../../tamalelibs/models/entity.model';
import { TamDashboardMapTileService } from './tam-dashboard-map-tile.service';
import { DashboardTileService } from '../dashboard-tile.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../redux';
import { DashboardActionTypes } from '../../../redux/actions/dashboard.actions';
import { LocationExpand } from '../../calendar-dialog/calendar-dialog.model';
import { NoteEntry } from '../../../tamalelibs/models/note-entry.model';
import { ThreadDetailService } from '../../../services/thread-detail.service';
import { CalendarService } from '../../../tamalelibs/services/calendar.service';

@Component({
    selector: 'tam-dashboard-map-tile',
    templateUrl: './tam-dashboard-map-tile.component.html',
    styleUrls: ['./tam-dashboard-map-tile.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class TamDashboardMapTileComponent implements OnInit, AfterViewInit, OnDestroy, TamDashboardTileBaseComponent {
    @Input() config?: TamDashboardMapTileConfiguration; // for show event on map tile
    @Input() mapConfig?: MapConfig = new MapConfig();
    @Input() mapContactModel?: MapContactModel = new MapContactModel();
    @Input() isFromShowEventOnMapTile = false;

    data: any;
    isMapShow = false;
    isShowEventOnMap = false;
    isTripShow = false;
    isLoading = false;
    isMapTileEnabled = false;
    isPrintMode = false;
    isShowNearby = false;
    id: string; // set tile id;
    location: any;
    selectedMapContact: MapContactModel;
    turnOffMapTileMsg = '';

    private _destroySubscriptions: Array<Subscription> = [];
    private _config: TamDashboardMapTileConfiguration;
    private _afterViewFeedback$ = new Subject<string>();
    private _searchMarker: TamDashboardTileData;
    private _isFromTrip = false;
    /** save last search address */
    private _lastSearchAddress: any;
    private _lastInputValue: any;
    selectedAddress: any;

    constructor(
        private _calendarService: CalendarService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _threadDetailService: ThreadDetailService,
        private _storeQuerier: StoreQuerierService,
        private _tamDashboardMapTileService: TamDashboardMapTileService,
        private _dashboardTileService: DashboardTileService,
        private _store?: Store<AppState>,
    ) { }

    ngOnInit() {
        // map tile dialog
        if (this.isFromShowEventOnMapTile) {
            this.isShowNearby = true;
            if (this.config) {
                this.isMapShow = true;
                this.isShowEventOnMap = true;
                this._config = this.config;
                // set tile id.
                this.id = this.config.id;
                this._init();

                const action = {
                    type: 0,
                    payload: {
                        mapContactModel: this.mapContactModel,
                        isFromShowEventOnMapTile: true
                    }
                };
                this.setSelectedAddress(action);
                this.location = this.mapConfig.markerArray[0];
            }
        }

        this._initMapTileEnableStatus();
        this._tamDashboardMapTileService.feedbackSubject$
            .pipe(filter(res => this._config && res.id === this._config.id))
            .subscribe(res => {
                if (res.type === MapAction.OPEN_NEARBY) {
                    this.isShowNearby = true;
                    this.location = res.payload;
                    this._lastSearchAddress = this.location;
                } else if (res.type === MapAction.OPEN_TRIP) {
                    this.isShowNearby = false;
                    this.isTripShow = true;
                    this.selectedMapContact = new MapContactModel();
                    const data: TamDashboardTileData = res.payload;
                    this.selectedMapContact.latitude = data.latitude;
                    this.selectedMapContact.longitude = data.longitude;
                    this.selectedMapContact.contact = data.detail;
                    this.selectedMapContact.selectedAddress = data.address;
                    this.selectedMapContact.selectedAddressType = data.addressType;
                    this._lastSearchAddress = data;
                } else if (res.type === MapAction.ADD_STOP) {
                    this.isShowNearby = false;
                    this.isTripShow = true;
                } else if (res.type === MapAction.APPLY_NEARBY) {
                    if (this._isFromTrip) {
                        this.mapConfig.markerArray.forEach(item => {
                            item.isAddStop = true;
                        });
                    }
                }
            });
    }

    ngAfterViewInit(): void {
        this._afterViewFeedback$.next(TamDashboardEvents.TILE_AFTER_VIEW_INIT);
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(element => element.unsubscribe());
        if (this._config) {
            this._config.destroy();
        }
    }

    clickSearchNearby() {
        this.isShowNearby = true;
    }

    eventHandler(action: any) {
        if (action.type === MapTripActionType.closeTripPanel) {
            this.isTripShow = false;
            if (this.mapConfig.markerArray && this.mapConfig.markerArray.length === 0) {
                this.mapConfig.markerArray = this.mapConfig.markerArray.concat(this._searchMarker);
            } else {
                this.mapConfig.markerArray.forEach(item => {
                    item.isAddStop = false;
                });
            }
            this.mapConfig.actionSubject$.next({
                type: TamDashboardEvents.REFRESH_MAP_TILE,
                payload: this.mapConfig
            });
        } else if (action.type === MapTripActionType.refreshTripDirections) {
            const data = _lodash.cloneDeep(action.payload);
            this._lastInputValue = _lodash.cloneDeep(this.mapConfig.markerArray[0]);

            this.mapConfig.actionSubject$.next({
                type: TamDashboardEvents.REFRESH_MAP_TRIP,
                payload: action.payload
            });
            // add detailType for judge map tile type.
            data['detailType'] = TamDashboardEvents.REFRESH_MAP_TRIP;
            // set trip data to store
            this._store.dispatch({
                type: DashboardActionTypes.SAVE_TILE_DATA,
                payload: {
                    id: this._config.id,
                    data: data,
                }
            });

        } else if (action.type === AutocompleteActionType.searchNearby) {
            this.isShowNearby = true;
            // if data from search panel ,set markerArray to location,because it includes address detail.
            if (!action.payload.isFromDirectionInput) {
                if (this.mapConfig.markerArray && this.mapConfig.markerArray.length === 0) {
                    if (this._lastInputValue) {
                        this.location = this._lastInputValue;
                    } else {
                        const value: MapContactModel = action.payload.content;
                        this.location = new TamDashboardTileData(value.latitude, value.longitude, value.entityId, value.entityName ? value.entityName : value.selectedAddress, value.entityType, value.contact, value.selectedAddress, value.selectedAddressType);
                    }
                } else {
                    this.location = _lodash.cloneDeep(this.mapConfig.markerArray[0]);
                }
                this._lastSearchAddress = _lodash.cloneDeep(this.location);
            } else {
                const value: MapContactModel = action.payload.content;
                // why use value.contact old code use contact for saveToServer .can't unify it.
                this.location = new TamDashboardTileData(value.latitude, value.longitude, value.entityId, value.entityName ? value.entityName : value.selectedAddress, value.entityType, value.contact, value.selectedAddress, value.selectedAddressType);
            }
            this._isFromTrip = action.payload.isTrip;
        }
    }

    setConfig(config: TamDashboardMapTileConfiguration): boolean {
        /*
            fix bug: TAM-29118, has only one new config subscribe event
            dashboard view page -> change focus/refresh tile -> new config -> config init() -> config setConfig
            confirm the component every use the new config, not old config
            confirm the component every call new config function, example this._config.labelContent
        */
        this._config = config;
        // set tile id.
        this.id = config.id;
        this._init();
        return true;
    }

    /*
     * send address to map-tile.config which will contain all business logics
     */
    setSelectedAddress(action: any) {
        if (action.type === AutocompleteActionType.predictionSelected) {
            this.selectedMapContact = action.payload.mapContactModel;
            this._config.actionSubject$.next({
                type: TamDashboardEvents.SET_MAP_ADDRESS,
                id: this._config.id,
                payload: {
                    mapContactModel: this.selectedMapContact,
                    isFromShowEventOnMapTile: action.payload.isFromShowEventOnMapTile
                }
            });
        } else if (action.type === AutocompleteActionType.directToMapTrip) {
            this.isTripShow = true;
            this.selectedMapContact = action.payload;
            if (this.mapConfig.markerArray && this.mapConfig.markerArray.length > 0) {
                this.mapConfig.markerArray.forEach(item => {
                    item.isAddStop = true;
                });
            }
        } else if (action.type === AutocompleteActionType.searchNearby) {
            this.isShowNearby = true;
            this._isFromTrip = false;
            if (this.mapConfig.markerArray && this.mapConfig.markerArray.length > 0) {
                this._lastSearchAddress = _lodash.cloneDeep(this.mapConfig.markerArray[0]);
                this.location = this.mapConfig.markerArray[0];
            }
        } else if (action.type === AutocompleteActionType.showNearby) {
            this.mapConfig.markerArray = [];
            const nearbyData = action.payload;
            const nearbyEntity = nearbyData[0];
            const nearbyGoogle = nearbyData[1];
            const nearbySearch = nearbyData[2];
            const nearbyEvent = nearbyData[3];
            this.mapConfig.markerArray.push(nearbySearch);
            if (nearbyEntity && nearbyEntity.length > 0) {
                const entityMarkerArray: Array<TamDashboardTileData> = [];
                nearbyEntity.forEach((item, index) => {
                    const marker: TamDashboardTileData = new TamDashboardTileData(null, null);
                    if (item['entity-type']['link']['phid'] === 'Contact') {
                        // conatct type
                        const contact = Contact.parse(item);
                        marker.latitude = contact.webAddress[0].latitude;
                        marker.longitude = contact.webAddress[0].longitude;
                        marker.entityName = contact.shortName;
                        marker.entityType = businessConstants.addressType.contact;
                        marker.entityId = contact.id;
                        marker.detail = contact;
                        marker.address = this._dashboardTileService.getAddress(contact.webAddress[0]);
                        marker.addressType = contact.webAddress[0].name;
                    } else {
                        const entity = Entity.parse(item);
                        marker.latitude = entity.webAddress[0].latitude;
                        marker.longitude = entity.webAddress[0].longitude;
                        marker.entityName = entity.shortName;
                        marker.entityType = businessConstants.addressType.entity;
                        marker.entityId = entity.id;
                        marker.detail = entity;
                        marker.address = this._dashboardTileService.getAddress(entity.webAddress[0]);
                        marker.addressType = entity.webAddress[0].name;
                    }
                    entityMarkerArray.push(marker);
                });
                this.mapConfig.markerArray = this.mapConfig.markerArray.concat(entityMarkerArray);
            }
            if (nearbyGoogle && nearbyGoogle.length > 0) {
                const googleMarkerArray = [];
                nearbyGoogle.forEach((item, index) => {
                    if (index > 0) {
                        const marker: TamDashboardTileData = new TamDashboardTileData(null, null);
                        marker.latitude = item.geometry.location.lat();
                        marker.longitude = item.geometry.location.lng();
                        marker.entityName = item.name;
                        marker.address = item.vicinity;
                        marker.entityId = index + item.vicinity;
                        marker.entityType = businessConstants.addressType.google;
                        marker.detail = item;
                        googleMarkerArray.push(marker);
                    }
                });
                this.mapConfig.markerArray = this.mapConfig.markerArray.concat(googleMarkerArray);
            }
            if (nearbyEvent && nearbyEvent.length > 0) {
                const eventMarkerArray: Array<TamDashboardTileData> = [];
                nearbyEvent.forEach(item => {
                    // get location information from properties
                    const marker: TamDashboardTileData = new TamDashboardTileData(null, null);
                    marker.threadId = item.thread.data.id;
                    const event = NoteEntry.parse(item);
                    marker.eventProperties = this._getEventPropertiesByNoteInfo(event);
                    const locationInfo = event.adhocs.get(businessConstantsLibs.calendar.ownProperties.locationId);
                    const locationExpandInfo = event.adhocs.get(businessConstantsLibs.calendar.ownProperties.locationExpandId);
                    if (locationExpandInfo && locationInfo) {
                        const location = locationInfo.value;
                        const locationExpand: LocationExpand = JSON.parse(locationExpandInfo.value);
                        marker.latitude = locationExpand.latitude;
                        marker.longitude = locationExpand.longitude;
                        marker.entityType = businessConstants.addressType.event;
                        marker.entityId = locationExpand.linkedEntityId;
                        marker.entityName = event.subject ? event.subject : event.calculatedSubject;
                        marker.address = location;
                        marker.addressType = locationExpand.addressName;
                    }
                    eventMarkerArray.push(marker);
                });
                this.mapConfig.markerArray = this.mapConfig.markerArray.concat(eventMarkerArray);
            }
            this._setFromTripNearbyData();
            this.mapConfig.actionSubject$.next({
                type: TamDashboardEvents.REFRESH_MAP_TILE,
                payload: this.mapConfig
            });
            const data = _lodash.cloneDeep(this.mapConfig.markerArray);
            this._store.dispatch({
                type: DashboardActionTypes.SAVE_TILE_DATA,
                payload: {
                    id: this._config.id,
                    data: data,
                }
            });
        } else if (action.type === AutocompleteActionType.closeNearby) {
            this.isShowNearby = false;
            if (action.payload.isApply && this._lastSearchAddress) {
                // close nearby panel should set last search address.
                this.mapConfig.markerArray = [this._lastSearchAddress];
                this._store.dispatch({
                    type: DashboardActionTypes.SAVE_TILE_DATA,
                    payload: {
                        id: this._config.id,
                        data: this.mapConfig.markerArray,
                    }
                });
            }
        } else if (action.type === AutocompleteActionType.noData) {
            this.mapConfig.markerArray = [action.payload];
            this.mapConfig.actionSubject$.next({
                type: TamDashboardEvents.REFRESH_MAP_TILE,
                payload: this.mapConfig
            });
        }
    }

    /**
     * Get event properties by the adhoc values in note
     * @param event
     * @returns eventProperties
     */
    private _getEventPropertiesByNoteInfo(event: NoteEntry) {
        if (event && event.adhocs) {
            // get attendees
            const attendees = event.adhocs.get(businessConstantsLibs.calendar.ownProperties.attendeesId);
            // get location
            const location = event.adhocs.get(businessConstantsLibs.calendar.ownProperties.locationId);
            // get locationExpand
            const locationExpand = event.adhocs.get(businessConstantsLibs.calendar.ownProperties.locationExpandId);
            const displayLocation = this._calendarService.getDisplayLocationByLocationExpand(location.value, locationExpand);
            // get date
            const displayDate = event.displayDate;
            const allDayEvent = event.adhocs.get(businessConstantsLibs.calendar.ownProperties.allDayId);
            let isAllDayEvent = false;
            if (allDayEvent) {
                isAllDayEvent = allDayEvent.value.toLocaleLowerCase() === 'true' ? true : false;
            }
            let endDate = 0;
            const endDateObj = event.adhocs.get(businessConstantsLibs.calendar.ownProperties.endDateId);
            if (endDateObj) {
                endDate = parseFloat(endDateObj.value);
            }
            const date = this._threadDetailService.getCalendarDateInfo(isAllDayEvent, displayDate, endDate);

            const eventProperties = {
                entities: event.entities,
                eventType: event.type.name,
                particpants: attendees ? attendees.expandValue : [],
                location: displayLocation,
                date: date,
            };
            return eventProperties;
        } else {
            return {
                entities: [],
                eventType: '',
                particpants: [],
                location: '',
                date: ''
            };
        }
    }

    private _setFromTripNearbyData() {
        if (this._isFromTrip && this.mapConfig.markerArray && this.mapConfig.markerArray.length > 0) {
            this.mapConfig.markerArray.forEach(item => {
                item.isAddStop = true;
            });
        }
    }

    private _init() {
        this._destroySubscriptions.forEach(element => element.unsubscribe());
        this._destroySubscriptions.push(
            this._config.actionSubject$.pipe(
                filter((action: any) => action && action.id === this._config.id),
            ).subscribe(action => this._onSubscribeActions(action)),
            this._afterViewFeedback$.subscribe((payload) => {
                if (payload === TamDashboardEvents.TILE_AFTER_VIEW_INIT) {
                    this._config.feedbackSubject$.next({
                        type: TamDashboardEvents.TILE_AFTER_VIEW_INIT,
                        id: this._config.id
                    });
                }
            })
        );
    }

    private _initMapTileEnableStatus() {
        // get map tile enable status to hide and show map
        const systemConfig = this._storeQuerier.queryBySelector(getSystemConfigState);
        if (systemConfig && systemConfig.maptile) {
            this.isMapTileEnabled = systemConfig.maptile['enable'];
        }
        this.turnOffMapTileMsg = businessConstants.mapTileErrorMessage.turnOffMapTile;
        this._updateChangesToUI();
    }

    private _onSubscribeActions(action) {
        if (action.type === TamDashboardActions.SET_MAP_LOADING_STATUS) {
            this.isLoading = true;
            this.isMapShow = true;
        } else if (action.type === TamDashboardActions.SET_TILE_DATA) {
            this.isPrintMode = false;
            if (action.payload) {
                this.isPrintMode = action.payload.isPrint;
            }
            if (action.payload && action.payload.detailType === TamDashboardEvents.REFRESH_MAP_TRIP) {
                this.mapConfig.actionSubject$.next({
                    type: TamDashboardEvents.REFRESH_MAP_TRIP,
                    payload: action.payload,
                    isRefresh: action.isRefresh
                });
            } else {
                // set value for lat and lng to refresh map
                if (action.payload && action.payload.length > 0) {
                    this.mapConfig.markerArray = action.payload;
                    this._searchMarker = _lodash.cloneDeep(action.payload);
                    this.mapConfig.actionSubject$.next({
                        type: TamDashboardEvents.REFRESH_MAP_TILE,
                        payload: this.mapConfig,
                        isRefresh: action.isRefresh,
                        isPrint: this.isPrintMode,
                    });
                }
            }
            this._config.feedbackSubject$.next({
                type: TamDashboardEvents.TILE_LOADED_DATA,
                id: this._config.id
            });
            this.isLoading = false;
            this.isMapShow = true;
            if (action.isRefresh) {
                this.isTripShow = false;
                this.isShowNearby = false;
            }

            this._updateChangesToUI();
        }
    }

    private _updateChangesToUI() {
        if (!this._changeDetectorRef[businessConstants.common.changeDetectorDestroyedIdentifier]) {
            this._changeDetectorRef.detectChanges();
        }
    }

}
